<!-- 上报主页  -->
<template>
  <div class='monitorRptIndex'>
    <!-- <v-header :headTitle='headTitle' :isBack='true' :pageName="pageName" ></v-header> -->
    <div class="container">
      <div class="swipe-box">
        <!-- <div class='swipe-text'>为您推荐</div> -->
        <van-swipe
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item
            v-for='(item,index) in swipeData'
            @click='handleClickSwipeItem(item)'
            :key='index'
          >
            <img
              :src="downloadPath+item.advertisingImages"
              alt=""
            >
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="editRole-box">
        <div class='userIfo df-center'>
          <span class='wei'>您的角色为:</span>
          <div class="right-box">
            <div
              class="post-box post-width df-center"
              @click='handleEditUserInfo(1)'
            >
              <span>{{editPostName?editPostName:_userInfo.data.postName}}</span>
              <img
                src="../../assets/images/edit-role.png"
                alt=""
              >
            </div>
            <div
              class="post-box df-center"
              @click='handleEditUserInfo(2)'
            >
              <span class='ellipsis'>{{roleName}}</span>
              <img
                v-if='_userInfo.data.postId!=4'
                src="../../assets/images/edit-role.png"
                alt=""
              >
            </div>
          </div>
        </div>
        <p>按如下步骤参与全国手卫生调查</p>
      </div>
      <!-- 感控科主任或者专职感控人员显示所有内容  非院感主任和专职人员的全员管理员（isAdmin==1）只显示步骤一和步骤二-->
      <div class="step-box" v-if='_userInfo.data.postId==1||_userInfo.data.postId==2||_userInfo.data.isAdmin==1' >
        <div class="step-item" v-for='(item,index) in listData' :key='index' :style="{'margin-bottom':item.isShowContent?'0px':'6px'}" >
          <div class="item-title df-between" @click='handleShowContent(index)' v-if='_userInfo.data.isAdmin==1&&_userInfo.data.postId!=1&&_userInfo.data.postId!=2?index<2:true'>
            <div class="title-text">步骤{{item.linkOrder}}:{{item.linkName}}</div>
            <div class="img-box">
              <img src="../../assets/images/arrow-top.png" v-if='item.isShowContent' alt="" >
              <img src="../../assets/images/arrow-bottom.png" v-else alt="" >
            </div>
          </div>
          <div class="item-content-box" v-if='item.isShowContent' >
            <van-notice-bar left-icon="volume-o" :text="item.describes" />
            <div class="item-content df-between" @click='handleItemClick(d,index,item)' v-for='(d,idx) in item.children' :key='idx' >
              <div class="left df-column-between">
                <div class="left-title"> {{d.indexName}} <span class='asterisk' v-if='d.isRequired==1' >*</span></div>
                <span>{{d.indexExplain}}</span>
              </div>
              <template v-if="!d.isShowSuo">
                <div class="right df-center" v-if='d.indexType=="4"&&d.state==1' > 已完成{{learnNum>99?'99+人':learnNum>0&&learnNum<=99?learnNum+'人':'0人'}} </div>
                <div class="right df-center" v-if='d.indexType!="4"&&d.state==1' > 已完成 </div>
                <div class="right df-center" v-if='d.state==0&&d.indexType=="3"' > 待审核({{notAuditNumber}}) </div>
                <div class="right df-center" v-if='d.state==0&&d.indexType!="3"' :class="{'can-report':d.canSubmit == '1'}"> {{d.canSubmit == '1' ? (dateObj.stateCN?dateObj.stateCN:'可上报') : '未完成'}} </div>
              </template>
              <div class="lock-img" v-else>
                <img src="../../assets/images/index-suo.png" alt="" >
              </div>
            </div>
            <div class="edit-range df-column-between" v-if='index==1&&reportStatus==0' >
              <p>默认仅手卫生观察员提交的时机数才纳入上报，如需调整请点击</p>
              <span @click='handleGoStatisticsRange(item)'>修改上报统计范围（需感控科主任操作）</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 其他角色根据选择的手卫生监测上报执行角色显示（只显示子项） -->
      <div class="step-box" v-else >
        <div class="step-item" v-for='(item,index) in listData' :key='index' :style="{'margin-bottom':item.isShowContent?'0px':'6px'}" >
          <div class="item-content-box" v-if='index==1' >
            <div class="item-content df-between" @click='handleItemClick(d,index,item)' v-for='(d,idx) in item.children' :key='idx' >
              <template v-if='d.indexType!="4"?roleCodeData[0]==1:true'>
                <div class="left df-column-between">
                  <div class="left-title"> {{d.indexName}} <span
                      class='asterisk'
                      v-if='d.isRequired==1'
                    >*</span></div>
                  <span>{{d.indexExplain}}</span>
                </div>
                <template v-if="!d.isShowSuo">
                  <div class="right df-center" v-if='d.indexType=="4"&&d.state==1' > 已完成{{learnNum>99?'99+人':learnNum>0&&learnNum<=99?learnNum+'人':'0人'}} </div>
                  <div class="right df-center" v-if='d.indexType!="4"&&d.state==1' > 已完成 </div>
                  <div class="right df-center" v-if='d.state==0' :class="{'can-report':d.canSubmit == '1'}"> {{d.canSubmit == '1' ? (dateObj.stateCN?dateObj.stateCN:'可上报') : '未完成'}} </div>
                </template>
                <div class="lock-img" v-else >
                  <img src="../../assets/images/index-suo.png" alt="" >
                </div>
              </template>
            </div>
            <div class="edit-range df-column-between" v-if='reportStatus==0' >
              <p>默认仅手卫生观察员提交的时机数才纳入上报，如需调整请点击</p>
              <span @click='handleGoStatisticsRange(item)'>修改上报统计范围（需感控科主任操作）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="confirm-report-box" v-if='isShowButton'>
        <img
          src="../../assets/images/tips.png"
          v-if='reportStatus==0'
          alt=""
        >
        <div
          class="confirm-report df-center"
          v-if='reportStatus==0'
          @click='handleHosReport'
          :style="{'background-color':notStart||isFinished?'#999':'rgba(28, 145, 255, 1)'}"
        > {{isFinished?'逾期未报（上报已截止）':'确定上报'}} </div>
        <div
          class="confirm-report df-center"
          v-if='reportStatus==1&&!isFinished'
          @click='handleRecallReport'
          :style="{'background-color':notStart||isFinished?'#999':'rgba(28, 145, 255, 1)'}"
        > 撤回上报</div>
        <div
          class="yet-report df-center"
          v-if="reportStatus==1"
        >已上报</div>
        <!-- <div class="text-box">
          <div>上报内容可由指定角色分别填写完提交，再由“感控科主任”审核后并在{{stepThreeBeginTime}}-{{stepThreeEndTime}}后确定上报（*为必报内容）</div>
        </div> -->
        <div class="text-box">
          <div>上报内容可由指定角色分别填写完提交，再由“感控科主任”审核后 <span style="color:#26b4ff;">并在{{stepThreeEndTime}}之前 </span>确定上报（*为必报内容）。</div>
        </div>
      </div>
      <div class="help-box df-center">
        <span style='color: #323233;'>需要帮助？</span>
        <span
          style='color: #26b4ff;'
          @click='handleGoKf'
        >找我的客服</span>
      </div>
      <van-popup v-model="isShowRoleSelect" @close='handleClose'>
        <roleSelect
          :postId='_userInfo.data.postId'
          :roleCodeData='roleCodeData'
          v-on:conFirmRole='conFirmRole'
        ></roleSelect>
      </van-popup>
      <van-popup v-model="isShowReconfirm" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title" style='text-align:center;'>确定是否上报？</div>
          </div>
          <div class="btn-box df-between">
            <div class="btn btn-gray df-center" @click='handleBtnLeft' >取消</div>
            <div class="btn df-center" @click='handleBtnRight' >确定</div>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="isShowNotSignGuide" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title xiexie">上报成功，谢谢参与！</div>
            <div class="check-btn check-btn1 df-center" @click='handleToMonitorStatistics' v-if="isShowGoReportBtn">去查看本次上报数据统计</div>
            <div class="check-btn check-btn2 df-center" @click='handleToscenesDetail'>去了解手卫生管理先进经验</div>
          </div>
          <div class="line"></div>
          <div class="close-dalog" @click='handleCloseNotSignGuide' >
            <img src="../../assets/images/reportSuccess-close.png" alt="">
          </div>
        </div>
      </van-popup>
      <!-- <dragIndex v-on:handleBackApp='handleBackApp'></dragIndex> -->
      <v-dalog v-on:handleOk='handleOk' :isCenter='true' :isShowDalog='isShowDalog' :dalogContent='dalogContent'></v-dalog>
    </div>
    <!-- <v-footer></v-footer> -->
  </div>
</template>

<script>
  import { Toast, Dialog } from 'vant'
  import { mapState } from 'vuex'
  import roleSelect from './roleSelect.vue'
  import dragIndex from './dragIndex.vue'
  import header from '../../components/header/header'
  import footer from '../../components/footer/footer.vue'
  import vDalog from '../../components/dalog/v-dalog.vue'


  export default {
    data() {
      return {
        dateObj:{},
        isShowGoReportBtn:false,
        dalogContent:'已关闭修改执行角色功能，如需操作请与本院感控科主任联系修改。',
        isShowDalog:false,
        isShowButton:false,
        isManagerUser:'',
        editPostName:'',
        swiftRoleAbility:'', // 0表示设置了不允许修改1表示可以修改
        isAdmin:'0', //  0 非管理员  1 全院 2 院区 3 单元
        isShowReconfirm:false,//是否二次确认
        isShowNotSignGuide:false,//是否显示未签约引导
        isSign:'',//是否签约
        notStart:false, // 活动未开始
        isFinished:false, // 活动已结束
        stepThreeBeginTime:'', // 步骤3开始时间
        stepThreeEndTime:'',// 步骤3结束时间
        notAuditNumber:0,
        taskId: '',
        batch: '',
        headTitle: localStorage.getItem('taskName'),
        pageName: '',
        sceneId: '',
        swipeData: [],
        roleData: [
          {
            name: '1',
            text: '手卫生观察员',
          },
          {
            name: '2',
            text: '其他数据监测员',
          },
          {
            name: '3',
            text: '其他医务人员',
          },
        ],
        roleCodeData: [], // 存储选中角色code
        roleName: '',
        isShowRoleSelect: false,
        isAuth: '',
        reportStatus: '0',
        learnNum:0,
        listData: [],
        localUserPost: '',
        localDeptStandardList: '',
      }
    },
    created() {
      this.dateObj = JSON.parse(localStorage.getItem('dateObj'))
      if(new Date(this.dateObj.hospitalDate.replace(/\-/g, '/')).getTime()<new Date().getTime()){
        this.isShowGoReportBtn = true
      }
      this.roleCodeData = localStorage.getItem('roleCode').split(',')
      this.handleRolePreview()
      setTimeout(() => {
        this.isManagerUser = localStorage.getItem('isManagerUser')
        this.isAuth = localStorage.getItem('isAuth')
        this.taskId = localStorage.getItem('taskId')
        this.batch = localStorage.getItem('batch')
        this.initData()
        this.initSwipeData()
        this.initNotAudit()
        this.initUserHandActivityInfo()
        console.log(this.$router,'erer');
      }, 600);
    },
    mounted() {
      let _this = this
      if(sessionStorage.getItem('isEditRole') == '1'){
        this.isShowRoleSelect = true
        sessionStorage.removeItem('isEditRole')
      }
      window.refreshMonitorRptIndex = function(){
        setTimeout(() => {
          _this.initUserHandActivityInfo()
          _this.initData()
        }, 600);
      }
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
        baseUrl: (state) => state._base,
        downloadPath: (state) => state.downloadPath,
        _studyExamBase:  (state) => state._studyExamBase,
      }),
    },
    components: {
      'v-footer': footer,
      'v-header': header,
      roleSelect,
      dragIndex,
      'v-dalog':vDalog
    },
    methods: {
      handleUnfoldItemIndex(){
        // 记录离开页面展开的项
        this.listData.forEach((v,i)=>{
          if(v.isShowContent){
            sessionStorage.setItem('unfoldItemIndex',i)
          }
        })
      },
      initNotAudit(){
        let params = {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          data: {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            isAuth:'2,6'
          }
        };
        this.$http.getUserCountByAuthorState(params).then((res) => {
          if (res.code === 0) {
            this.notAuditNumber = res.data
          } else {
            this.$toast(res.msg);
          }
        });
      },
      initReportStatus() {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskId: this.taskId,
            batch: this.batch,
            sceneId: this.sceneId,
          },
          malVersion: 'A0',
        }
        this.$http.getReportingCompanyStatus(params).then((res) => {
          if (res.code === 0) {
            this.reportStatus = res.data[0].reportType
            localStorage.setItem('reportStatus',this.reportStatus)
            this.learnNum = res.data[0].learnNum
          } else {
            this.$toast(res.msg)
          }
        })
      },
      // 获取用户手卫生活动的用户信息
      initUserHandActivityInfo(){
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: "",
          comId: this._userInfo.data.comId,
          data: {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            handTaskId: this.taskId
          },
          malVersion: "A0"
        };
        this.$http.getUserHandActivityInfo(params).then((res) => {
          if (res.code === 0) {
            this.editPostName = res.data.postName
            this.swiftRoleAbility = res.data.swiftRoleAbility
            this.isAuth = res.data.isAuth
            this.localUserPost = res.data.userPost
            this.localDeptStandardList = res.data.deptStandardList
          } else {
            this.$toast(res.msg);
          }
        });
      },
      initData() {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskId: this.taskId,
          },
          malVersion: 'A0',
        }
        this.$http.getReportingTaskLinkInfo(params).then((res) => {
          if (res.code === 0) {
            this.listData = res.data
            this.stepThreeBeginTime = res.data[2].beginTime.substring(5,7)+'月'+res.data[2].beginTime.substring(8,10)+'日'
            this.stepThreeEndTime = res.data[2].endTime.substring(5,7)+'月'+res.data[2].endTime.substring(8,10)+'日'
            if(new Date(res.data[2].beginTime.replace(/\-/g, '/')).getTime()>new Date().getTime()){
              this.notStart = true  // 未开始
            }
            if(new Date().getTime()>new Date(res.data[2].endTime.replace(/\-/g, '/')).getTime()){
              this.isFinished = true // 已结束
            }
            this.sceneId = this.listData[1].sceneId
            if (this.sceneId) {
              this.initReportStatus()
            }
            this.listData.forEach((v, i) => {
              if(sessionStorage.getItem('unfoldItemIndex') && sessionStorage.getItem('unfoldItemIndex') == i){
                this.$set(v, 'isShowContent', true)
              }else{
                this.$set(v, 'isShowContent', false)
              }
              this.$set(v, 'children', [])
              this.initChildRenData(v)
            })
          } else {
            this.$toast(res.msg)
          }
        })
      },
      initChildRenData(val) {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskLinkId: val.id,
            batch: this.batch,
          },
          malVersion: 'A0',
        }
        Promise.all([
          this.$http.getReportingTaskIndex(params).then((res) => {
            if (res.code === 0) {
              val.children = res.data
              this.isShowButton = true
            }
          })
        ]).then(()=>{
          this.handleShowSuoData()
        })
      },
      // 处理上报科室状态为未完成时显示小锁的图片的数据
      handleShowSuoData () {
        let flag = false
        this.listData.forEach((v,i)=>{
          v.children.forEach((x,y)=>{
            this.$set(x, 'isShowSuo', false)
            if (x.indexType == '2' && x.state == 0) { // 表示确定上报科室  还没有完成
              flag = true
            }
            if (flag && (x.indexType == '5' || x.indexType == '8' || x.indexType == '9')) { // 手卫生依从性监测  手卫生用品消耗量 手卫生消耗品微生物含量抽检
              this.$set(x, 'isShowSuo', true)
            }
          })
        })
      },
      initSwipeData() {
        let params = {
          userId: this._userInfo.data.userId,
          comId: this._userInfo.data.comId,
          data: {
            companyId: this._userInfo.data.comId,
            positionId: '6',
            userId: this._userInfo.data.userId,
          },
        }
        this.$http.searchSwipe(params).then((res) => {
          if (res.code === 0) {
            this.swipeData = res.data
          } else {
            this.$toast(res.msg)
          }
        })
      },
      // 处理角色显示
      handleRolePreview() {
        this.roleName = ''
        this.roleData.map((item, index) => {
          this.roleCodeData.map((item1, index1) => {
            if (item.name == item1) {
              if (this.roleCodeData.length>1&&index1 != this.roleCodeData.length) {
                this.roleName += item.text + '/'
              } else {
                this.roleName += item.text
              }
            }
          })
        })
      },
      handleShowContent(index) {
        this.listData.forEach((v, i) => {
          if (index == i) {
            this.listData[index].isShowContent =
              !this.listData[index].isShowContent
          } else {
            this.listData[i].isShowContent = false
          }
        })
      },
      // 点击轮播图
      handleClickSwipeItem(val) {
        this.$router.push({
          path: '/pdfList',
          query:{
            source:0,
            taskId:this.taskId,
            batch: this.batch
          }
        })
        // console.log(val, '跳转')
        // window.location.href = val.outsideUrl
      },
      handleOk(){
        this.isShowDalog = false
      },
      // 修改用户信息
      handleEditUserInfo(temp) {
        if (temp == 1) {
          if(this.isAuth == 2||this.isAuth == 6){
            Toast('您提交的个人信息待审核')
            return
          }
          try {
            uni.postMessage({
              data: {
                action: 'startType',
                data: 'user'
              }
            });
            window.webkit.messageHandlers.startType.postMessage('user')
          } catch (err) {
            window.gk.startType('user')
          }
        } else {
          if(this._userInfo.data.postId==4){
            console.log('其他角色不能编辑');
            return
          }
          if(this.swiftRoleAbility == '0'){
            this.isShowDalog = true
            return
          }
          if(this.isAuth != 1){
            Toast('需等您提交的个人信息审核通过之后才能进行操作')
            return
          }
          this.isShowRoleSelect = true
        }
      },
      // 点击步骤的某一项
      handleItemClick(temp,index,item) {
        console.log(temp,index, 'temp')
        let stepIsEnd = '0'
        if(temp.beginTime && temp.beginTime > new Date().getTime()){
          Toast('上报时间未到')
          return
        }
        if(temp.endTime && new Date().getTime() > temp.endTime){
          stepIsEnd = '1'
          if(temp.indexType == '1' || temp.indexType == '2' || temp.indexType == '3' || temp.indexType == '4'){
            Toast('活动已截止')
            return
          }
        }
        if(index==0&&this._userInfo.data.isAdmin!=1&&this._userInfo.data.postId!=1){
          Toast('只有感控科主任和全院管理员才能操作')
          return
        }
        if(index==2&&this._userInfo.data.postId!=1&&this._userInfo.data.postId!=2){
          Toast('只有感控科主任和专职感控人员才能操作')
          return
        }
        if((temp.path!='goApp'&&temp.path!='/inviteAudit'&&temp.path.indexOf('/knowledgeMeasurement') == -1)&&this.isAuth != 1){
          Toast('需等您提交的个人信息审核通过之后才能进行操作')
          return
        }
        switch (temp.path) {
          case 'goApp':
            try {
              uni.postMessage({
                data: {
                  action: 'startType',
                  data: 'hos_detail'
                }
              });
              window.webkit.messageHandlers.startType.postMessage('hos_detail')
            } catch (err) {
              window.gk.startType('hos_detail')
            }
            break
          default:
            let query = {
              'stepIsEnd':stepIsEnd
            }
            if ((temp.path.indexOf('/complianceMonitor') != -1||temp.path.indexOf('/qualityIndicatorsReport') != -1) && temp.isShowSuo) {
              Toast('需“感控科主任”或“全院管理员”完成步骤1中的任务“确定上报科室”，才能进行'+temp.indexName)
              return
            }
            if (temp.path == '/conFirmReportDept') {
              query.comeFrom = 'conFirmReportDept',
              query.batch = this.batch
            }
            // 步骤二相关
            if (
              temp.path.indexOf('/knowledgeMeasurement') != -1 ||
              temp.path.indexOf('/complianceMonitor') != -1
            ) {
              query.titleName = temp.indexName
              query.taskId = this.taskId,
              query.reportStatus = this.reportStatus == 0 ? 0 : 1
              query.taskLinkId = temp.taskLinkId
              query.userPost = this.localUserPost
              query.deptStandardList = this.localDeptStandardList
              query.indexLibId = temp.indexLibIds
            }
            // 步骤三相关
            if (temp.path.indexOf('/qualityIndicatorsReport') != -1) {
              query.taskLinkId = temp.taskLinkId
              query.batch =  this.batch
              query.reportStatus = this.reportStatus == 0 ? 0 : 1
              query.indexId = temp.id
              query.taskLinkId = temp.taskLinkId
              query.titleName = temp.indexName
            }
            if(temp.path.indexOf('/knowledgeMeasurement') != -1) {
               let  path = `${this._studyExamBase}/manager-intf/?#${temp.path}&userId=${this._userInfo.data.userId}&source=0&taskId=${this.taskId}&batch=${this.batch}`;  
               console.log(path,'去学习考试路径');
               location.href = path + (this._userInfo.data.uniHm == '1' ? '&uniHm=1' : '')
               return
            }
            if(temp.path != '/conFirmReportDept'){
              query.timeRange = item.beginTime.substring(0,11) + ' ~ ' + item.endTime.substring(0,11)
            }
            this.$router.push({
              path: temp.path,
              query: query,
            })
        }
      },
      // 跳转到上报统计范围页面
      handleGoStatisticsRange(temp) {
        // console.log(temp);
        // return
        if(this.isAuth != 1){
          Toast('需等您提交的个人信息审核通过之后才能进行操作')
          return
        }
        if (this._userInfo.data.postId == 1) {
          this.$router.push({
            path: '/statisticalRange',
            query: {
              taskId: this.taskId,
              taskLinkId: temp.children[0].taskLinkId,
              reportStatus: this.reportStatus == 0 ? 0 : 1
            },
          })
        } else {
          Toast('只有感控科主任才能操作')
        }
      },
      handleClose(){
        this.roleCodeData = [] // 需要先清空在获取，否则watch 监听不到变化（解决一个都不选时关闭了弹窗在打开弹窗没有勾选任何项问题）
        this.roleCodeData = localStorage.getItem('roleCode').split(',')
      },
      // 修改角色
      conFirmRole(val) {
        console.log(val,'val');
        if(val.length>0){
          localStorage.setItem('roleCode', val.join())
          this.roleCodeData = val
          this.isShowRoleSelect = false
          this.handleRolePreview()
          let params = {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            data: {
              comId: this._userInfo.data.comId,
              taskId: this.taskId,
              userPost: val.join(), // 1-手卫生观察员，2-其他数据检测员 3-其他医务人员
              userName: this._userInfo.data.cnName?this._userInfo.data.cnName:this._userInfo.data.userName,
              userId: this._userInfo.data.userId,
            },
          }
          this.$http.updateSwsReportingUser(params).then((res) => {
            this.$toast(res.msg)
          })
        }else{
          Toast('请先选择角色')
        }
      },
      // 返回感控工作间app
      handleBackApp() {
        this.backToApp()
      },
      // 关闭未签约引导
      handleCloseNotSignGuide(){
        this.isShowNotSignGuide = false
      },
      // 查看统计
      handleToMonitorStatistics(){
        this.$parent.fatherMethod();
      },
      // 跳转到场景详情 
      handleToscenesDetail(){
        // this.$router.push( { path:'/scenesDetail' } )
        window.location.href = 'https://dygk.gkgzj.com/activity/#/detail/scenesDetail?id=1375273667239346176&comeFrom=handMonitorRrported'

        // window.location.href = 'https://demo.gkgzj.com/activity/#/detail/scenesDetail?id=1372381679502491648&comeFrom=handMonitorRrported'
        // http://localhost:8089/#/detail/scenesDetail?id=1372381679502491648&comeFrom=handMonitorRrported
      },
      handleBtnLeft(){
        this.isShowReconfirm =false
      },
      // 确定上报
      handleBtnRight(){
        this.isShowReconfirm = false
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskId: this.taskId,
            batch: this.batch
          },
          malVersion: 'A0',
        }
        this.$http.swsReportComSubmit2021(params).then((res) => {
          if (res.code === 0) {
            this.initReportStatus()
            if(this._userInfo.data.isSign == 0){ // 医院未签约
              this.isShowNotSignGuide = true
            }
          } else {
            this.$toast(res.msg)
          }
        })
      },
      handleRecallReport(){
        if (this._userInfo.data.postId != 1) {
          Toast('只有感控科主任才能撤回')
          return
        }
        Dialog.confirm({
          message: "撤回上报后，您可以修改上报内容。修改完成之后，您需要再次上报！",
        })
          .then(() => {
            let params = {
              userId: this._userInfo.data.userId,
              comId: this._userInfo.data.comId,
              data: {
                taskId: this.taskId,
                comId: this._userInfo.data.comId
              }
            }
            this.$http.updateReportingState(params).then((res) => {
              if(res.code == 0){
                this.initReportStatus()
              }
              this.$toast(res.msg)
            })
          })
          .catch(() => {
            console.log("取消");
          });
      },
      handleHosReport() {
        if(this.isAuth != 1){
          Toast('需等您提交的个人信息审核通过之后才能进行操作')
          return
        }
        if(this.notStart){
          Toast('上报时间未到')
          return
        }
        if(this.isFinished){
          Toast('活动已截止')
          return
        }
        if (this._userInfo.data.postId != 1) {
          Toast('只有感控科主任才能上报')
          return
        }
        let flag = false
        this.listData.forEach((v, i) => {
          v.children.forEach((v1, i1) => {
            if (v1.isRequired == 1 && v1.canSubmit !='1' && v1.state != 1) {
              // 存在没有填完的项
              Toast('还有任务未完成，请先完成之后再上报')
              flag = true
              return
            }
          })
        })
        if (!flag) {
          this.isShowReconfirm = true
        }
      },
      handleGoKf() {
        // this.$router.push({
        //   path:'/customerService'
        // })
        // window.location.href = `${this.baseUrl}/gk2018/?entryId=Kf`
        window.location.href = `${this.baseUrl}/gk2018/?entryId=KfIMDirect&source=0`
      },
    },
  }
</script>
<style lang='scss' scoped>
  .monitorRptIndex {
    .container {
      .swipe-box {
        padding: 0px 12px 10px;
        background-color: #fff;
        .swipe-text {
          padding: 10px 0px;
          color: #666;
          font-size: 12px;
        }
        .my-swipe {
          height: 100px;
          border-radius: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .editRole-box {
        // margin-bottom: 10px;
        p {
          padding: 10px 12px;
          color: #666;
          font-size: 12px;
          background-color: #f2f2f2;
        }
        .userIfo {
          padding: 8px 0px 8px 12px;
          background-color: #fff;
          justify-content: flex-start;
          .wei{
            font-size: 14px;
            color: #333;
          }
          .right-box{
            display: flex;
            align-items: center;
          }
          .post-box {
            margin-left: 8px;
            padding: 2px 8px;
            background: #fdfbec;
            border-radius: 13px;
            span {
              font-size: 14px;
              color: #666;
            }
            img {
              margin-left: 3px;
              width: 15px;
              height: 15px;
            }
            .ellipsis {
              max-width: 120px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .post-width {
            margin-left: 5px;
            min-width: 100px;
            max-width: 140px;
          }
        }
      }
      .step-box {
        .step-item {
          background-color: #fff;
          .item-title {
            padding: 0px 12px;
            height: 50px;
            img {
              width: 18px;
              height: 18px;
            }
            .title-text{
              font-size: 17px;
              font-weight: bold;
            }
          }
          .item-content-box {
            .item-content {
              padding: 0px 12px;
              border-bottom: 1px solid #eee;

              .left {
                // height: 64px;
                padding: 10px 0px;
                .left-title {
                  margin-bottom: 5px;
                  font-size: 16px;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: 400;
                  color: #323233;
                  .asterisk {
                    margin-top: 3px;
                    color: red;
                    font-size: 16px;
                  }
                }
                span {
                  color: #999999;
                  font-size: 12px;
                }
              }
              .right {
                min-width: 96px;
                height: 30px;
                border: 1px solid #1c91ff;
                border-radius: 17px;
                color: #1c91ff;
                font-size: 14px;
              }
              .can-report{
                border: 1px solid #ff9d4a;
                color: #ff9d4a;
              }
              .lock-img {
                padding: 10px;
                img {
                  width: 15px;
                  height: 15px;
                }
              }
            }
          }
          .edit-range {
            height: 60px;
            padding: 10px 12px;
            background: #f2f2f2;
            font-size: 12px;
            p {
              color: #666666;
            }
            span {
              text-decoration: underline;
              color: #26b4ff;
            }
          }
        }
      }
      .confirm-report-box {
        position: relative;
        width: 90%;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        margin: 44px auto 45px;
        img {
          width: 126px;
          height: 25px;
          position: absolute;
          top: -20px;
          right: 0;
        }
        .confirm-report,
        .yet-report {
          height: 44px;
          margin: 0px auto 20px;
          background: rgba(28, 145, 255, 1);
          border-radius: 5px;
          font-size: 18px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
        }
        .yet-report {
          background: rgba(204, 204, 204, 1);
        }
      }
      .help-box {
        height: 40px;
        position: fixed;
        bottom: 50px;
        left: 0;
        width: 100%;
        background: #e5efff;
        span{
          font-size: 14px;
        }
      }
      .dalog-box {
        position: relative;
        width: 310px;
        background-color: #fff;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        border-radius: 10px;
        overflow: hidden;
        .dalog-content {
          padding: 40px 35px 31px;
          border-bottom: 1px solid #eee;
          .dalog-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
            text-align: center;
          }
          .check-btn{
            margin: 0px auto;
            height: 44px;
            border-radius: 4px;
            color: #fff;
          }
          .check-btn1{
            margin: 30px auto 15px;
            background: #1c91ff;
          }
          .check-btn2{
            border: 1px solid #1c91ff;
            color: #1c91ff;
          }
        }
        .btn-box {
          color: #26b4ff;
          .btn {
            flex: 1;
            padding: 12px 0px;
          }
          .btn-gray {
            color: #323233;
            border-right: 1px solid #eee;
          }
        }
        .close-dalog {
          position: absolute;
          top: 0px;
          right: 0px;
          padding: 10px;
          .icon-close {
            font-size: 18px;
          }
          img{
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
</style>